"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientExposedUrl = void 0;
var ClientExposedUrl;
(function (ClientExposedUrl) {
    ClientExposedUrl["WEBCOMPONENT_FINANCIAL_GOALS"] = "WEBCOMPONENT_FINANCIAL_GOALS";
    ClientExposedUrl["WEBCOMPONENT_NDA"] = "WEBCOMPONENT_NDA";
    ClientExposedUrl["WEBCOMPONENT_CASHFLOW"] = "WEBCOMPONENT_CASHFLOW";
    ClientExposedUrl["WEBCOMPONENT_CASHFLOW_INACTIVE"] = "WEBCOMPONENT_CASHFLOW_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER"] = "WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER";
    ClientExposedUrl["WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER_INACTIVE"] = "WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_RISKFLOW"] = "WEBCOMPONENT_RISKFLOW";
    ClientExposedUrl["WEBCOMPONENT_RISKFLOW_INACTIVE"] = "WEBCOMPONENT_RISKFLOW_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_EMERGENCY_SAVINGS"] = "WEBCOMPONENT_EMERGENCY_SAVINGS";
    ClientExposedUrl["WEBCOMPONENT_PERSONALIZED_PORTFOLIO"] = "WEBCOMPONENT_PERSONALIZED_PORTFOLIO";
    ClientExposedUrl["WEBCOMPONENT_PORTFOLIO_CUSTOMIZATION"] = "WEBCOMPONENT_PORTFOLIO_CUSTOMIZATION";
    ClientExposedUrl["WEBCOMPONENT_CUSTOM_GOAL"] = "WEBCOMPONENT_CUSTOM_GOAL";
    ClientExposedUrl["WEBCOMPONENT_CUSTOM_GOAL_INACTIVE"] = "WEBCOMPONENT_CUSTOM_GOAL_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_ACCOUNTS_AND_CONTRIBUTIONS"] = "WEBCOMPONENT_ACCOUNTS_AND_CONTRIBUTIONS";
    ClientExposedUrl["WEBCOMPONENT_ACCOUNT_CONTRIBUTIONS"] = "WEBCOMPONENT_ACCOUNT_CONTRIBUTIONS";
    ClientExposedUrl["WEBCOMPONENT_ACTIVITY_LOG"] = "WEBCOMPONENT_ACTIVITY_LOG";
    ClientExposedUrl["WEBCOMPONENT_PERFORMANCE"] = "WEBCOMPONENT_PERFORMANCE";
    ClientExposedUrl["WEBCOMPONENT_FAQ"] = "WEBCOMPONENT_FAQ";
    ClientExposedUrl["WEBCOMPONENT_TOOLS_RESOURCES"] = "WEBCOMPONENT_TOOLS_RESOURCES";
    ClientExposedUrl["WEBCOMPONENT_TOOLS_RESOURCES_INACTIVE"] = "WEBCOMPONENT_TOOLS_RESOURCES_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_MEDICARE_MATCH"] = "WEBCOMPONENT_MEDICARE_MATCH";
    ClientExposedUrl["WEBCOMPONENT_MEDICARE_MATCH_INACTIVE"] = "WEBCOMPONENT_MEDICARE_MATCH_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_MONEY_TO_WORK"] = "WEBCOMPONENT_MONEY_TO_WORK";
    ClientExposedUrl["WEBCOMPONENT_HEALTH_CARE_COST_ESTIMATOR"] = "WEBCOMPONENT_HEALTH_CARE_COST_ESTIMATOR";
    ClientExposedUrl["WEBCOMPONENT_CASH_FINDER"] = "WEBCOMPONENT_CASH_FINDER";
    ClientExposedUrl["WEBCOMPONENT_FIRST_MONTH_EXPERIENCE"] = "WEBCOMPONENT_FIRST_MONTH_EXPERIENCE";
    ClientExposedUrl["WEBCOMPONENT_FINANCIAL_PROFILE"] = "WEBCOMPONENT_FINANCIAL_PROFILE";
    ClientExposedUrl["WEBCOMPONENT_FINANCIAL_PROFILE_INACTIVE"] = "WEBCOMPONENT_FINANCIAL_PROFILE_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_ACCOUNTS_AND_HOLDINGS"] = "WEBCOMPONENT_ACCOUNTS_AND_HOLDINGS";
    ClientExposedUrl["WEBCOMPONENT_ACTIVE_IN_ADVICE"] = "WEBCOMPONENT_ACTIVE_IN_ADVICE";
    ClientExposedUrl["WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE"] = "WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE";
    ClientExposedUrl["WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE_INACTIVE"] = "WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_FINANCIAL_GOAL_TRADEOFFS"] = "WEBCOMPONENT_FINANCIAL_GOAL_TRADEOFFS";
    ClientExposedUrl["WEBCOMPONENT_MY_PLAN_PAGE"] = "WEBCOMPONENT_MY_PLAN_PAGE";
    ClientExposedUrl["WEBCOMPONENT_TRANSACTION_MANAGE_TRANSFERS"] = "WEBCOMPONENT_TRANSACTION_MANAGE_TRANSFERS";
    ClientExposedUrl["WEBCOMPONENT_CONFIRMATION_PAGE"] = "WEBCOMPONENT_CONFIRMATION_PAGE";
    ClientExposedUrl["WEBCOMPONENT_DAP_PLAN_ADHERENCE"] = "WEBCOMPONENT_DAP_PLAN_ADHERENCE";
    ClientExposedUrl["WEBCOMPONENT_SERVERLESS_MFE_EXEMPLAR"] = "WEBCOMPONENT_SERVERLESS_MFE_EXEMPLAR";
    ClientExposedUrl["WEBCOMPONENT_EXEMPLAR_FRONTEND"] = "WEBCOMPONENT_EXEMPLAR_FRONTEND";
    ClientExposedUrl["WEBCOMPONENT_MICROFRONTEND_EXEMPLAR"] = "WEBCOMPONENT_MICROFRONTEND_EXEMPLAR";
    ClientExposedUrl["WEBCOMPONENT_TAX_LOSS_OPTION"] = "WEBCOMPONENT_TAX_LOSS_OPTION";
    ClientExposedUrl["WEBCOMPONENT_REQUIRED_MINIMUM_DISTRIBUTION"] = "WEBCOMPONENT_REQUIRED_MINIMUM_DISTRIBUTION";
    ClientExposedUrl["WEBCOMPONENT_REQUIRED_MINIMUM_DISTRIBUTION_INACTIVE"] = "WEBCOMPONENT_REQUIRED_MINIMUM_DISTRIBUTION_INACTIVE";
    ClientExposedUrl["WEBCOMPONENT_DATA_AGGREGATION"] = "WEBCOMPONENT_DATA_AGGREGATION";
    ClientExposedUrl["WEBCOMPONENT_ACCOUNTS_DATA_AGGREGATION"] = "WEBCOMPONENT_ACCOUNTS_DATA_AGGREGATION";
    ClientExposedUrl["WEBCOMPONENT_OFFER_UPGRADE_DOWNGRADE"] = "WEBCOMPONENT_OFFER_UPGRADE_DOWNGRADE";
    ClientExposedUrl["WEBCOMPONENT_VMAP_POST_CONVERSION"] = "WEBCOMPONENT_VMAP_POST_CONVERSION";
    ClientExposedUrl["WEBCOMPONENT_EXTRAORDINARY_EXPENSES"] = "WEBCOMPONENT_EXTRAORDINARY_EXPENSES";
    ClientExposedUrl["WEBCOMPONENT_ACTIVE_RISK_ASSESSMENT"] = "WEBCOMPONENT_ACTIVE_RISK_ASSESSMENT";
    ClientExposedUrl["WEBCOMPONENT_PORTFOLIO_BUILDER"] = "WEBCOMPONENT_PORTFOLIO_BUILDER";
    ClientExposedUrl["WEBCOMPONENT_ADVICE_FUTURE_TRANSACTION"] = "WEBCOMPONENT_ADVICE_FUTURE_TRANSACTION";
    ClientExposedUrl["WEBCOMPONENT_DAP_INCOMES"] = "WEBCOMPONENT_DAP_INCOMES";
    ClientExposedUrl["WEBCOMPONENT_NUDGE"] = "WEBCOMPONENT_NUDGE";
    ClientExposedUrl["WEBCOMPONENT_SCREEN_TAKEOVER_HIERARCHY"] = "WEBCOMPONENT_SCREEN_TAKEOVER_HIERARCHY";
    ClientExposedUrl["WEBCOMPONENT_HOUSEHOLD_MANAGEMENT"] = "WEBCOMPONENT_HOUSEHOLD_MANAGEMENT";
    ClientExposedUrl["ACCOUNT_MAINTENANCE"] = "ACCOUNT_MAINTENANCE";
    ClientExposedUrl["ADOBE_ANALYTICS_MIN_JS"] = "ADOBE_ANALYTICS_MIN_JS";
    ClientExposedUrl["BACKEND_MONEY_TO_WORK"] = "BACKEND_MONEY_TO_WORK";
    ClientExposedUrl["BUY_SELL_INVESTMENTS"] = "BUY_SELL_INVESTMENTS";
    ClientExposedUrl["DA_MARKETING_PAGE"] = "DA_MARKETING_PAGE";
    ClientExposedUrl["DASHBOARD"] = "DASHBOARD";
    ClientExposedUrl["DA_DOMAIN"] = "DA_DOMAIN";
    ClientExposedUrl["EDIT_RETIREMENT"] = "EDIT_RETIREMENT";
    ClientExposedUrl["MONEY_TO_WORK_UNDERSTAND_YOUR_PLAN"] = "MONEY_TO_WORK_UNDERSTAND_YOUR_PLAN";
    ClientExposedUrl["GET_CASH"] = "GET_CASH";
    ClientExposedUrl["FASTLINK_SSO"] = "FASTLINK_SSO";
    ClientExposedUrl["FTW"] = "FTW";
    ClientExposedUrl["INST_EDIT_MY_INFO"] = "INST_EDIT_MY_INFO";
    ClientExposedUrl["INSTITUTIONAL_ONLY_ACCOUNTS"] = "INSTITUTIONAL_ONLY_ACCOUNTS";
    ClientExposedUrl["MANAGE_TRANSFERS"] = "MANAGE_TRANSFERS";
    ClientExposedUrl["MENU_DOMAIN_URLS_INVESTOR"] = "MENU_DOMAIN_URLS_INVESTOR";
    ClientExposedUrl["MENU_DOMAIN_URLS_PERSONAL"] = "MENU_DOMAIN_URLS_PERSONAL";
    ClientExposedUrl["MENU_DOMAIN_URLS_PERSONAL1"] = "MENU_DOMAIN_URLS_PERSONAL1";
    ClientExposedUrl["LOGON"] = "LOGON";
    ClientExposedUrl["OPEN_ACCOUNT"] = "OPEN_ACCOUNT";
    ClientExposedUrl["STATIC_WEBSERVICE"] = "STATIC_WEBSERVICE";
    ClientExposedUrl["RETAIL_EDIT_MY_INFO"] = "RETAIL_EDIT_MY_INFO";
    ClientExposedUrl["RETIREE_INSTITUTIONAL_REDIRECT"] = "RETIREE_INSTITUTIONAL_REDIRECT";
    ClientExposedUrl["RETIREE_REDIRECT"] = "RETIREE_REDIRECT";
    ClientExposedUrl["RISK_ATTITUDE_IFRAME"] = "RISK_ATTITUDE_IFRAME";
    ClientExposedUrl["RISK_ATTITUDE_IFRAME_ECS"] = "RISK_ATTITUDE_IFRAME_ECS";
    ClientExposedUrl["SELL_COMPANY_STOCKS"] = "SELL_COMPANY_STOCKS";
    ClientExposedUrl["WITHDRAWAL"] = "WITHDRAWAL";
    ClientExposedUrl["WITHDRAWAL_INELIGIBLE"] = "WITHDRAWAL_INELIGIBLE";
    ClientExposedUrl["FINANCIAL_GOAL_TRADEOFFS"] = "FINANCIAL_GOAL_TRADEOFFS";
    ClientExposedUrl["ADD_A_BANK"] = "ADD_A_BANK";
    ClientExposedUrl["WSA_FAQ"] = "WSA_FAQ";
    ClientExposedUrl["CONTRIBUTE_CASH_MFE"] = "CONTRIBUTE_CASH_MFE";
    ClientExposedUrl["WITHDRAW_CASH_MFE"] = "WITHDRAW_CASH_MFE";
    ClientExposedUrl["SCHEDULED_TRANSFERS_MFE"] = "SCHEDULED_TRANSFERS_MFE";
    ClientExposedUrl["APPOINTMENT_ALERTS"] = "APPOINTMENT_ALERTS";
    ClientExposedUrl["DIGITAL_ADVISOR_DASHBOARD"] = "DIGITAL_ADVISOR_DASHBOARD";
    ClientExposedUrl["W4R"] = "W4R";
    ClientExposedUrl["HOLDINGS"] = "HOLDINGS";
    ClientExposedUrl["PLAN_CALCULATOR"] = "PLAN_CALCULATOR";
    ClientExposedUrl["PE_WITHDRAW_LINK"] = "PE_WITHDRAW_LINK";
    ClientExposedUrl["PE_MY_ACCOUNT"] = "PE_MY_ACCOUNT";
    ClientExposedUrl["PE_WITHDRAW_LOAN_LINK"] = "PE_WITHDRAW_LOAN_LINK";
})(ClientExposedUrl = exports.ClientExposedUrl || (exports.ClientExposedUrl = {}));
